import React from 'react';

export default () => (
    <div className="view-header">
        <header className="title text-white">
            <h1 className="h4 text-uppercase">Airline Locations</h1>
            <p className="mb-0">List of airline locations</p>
        </header>
    </div>
);



// WEBPACK FOOTER //
// ./src/views/airline-location/view-header.js